import { RequiredDocuments } from './types'

export const initialRequiredDocuments: RequiredDocuments = {
  businessInformation: [],
  financialDocuments: [],
  individuals: [],
  corporateOwners: [],
  industryDocuments: [],
}
